"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.constructAdInteractionURL = constructAdInteractionURL;
exports.getAdSolutionHost = getAdSolutionHost;
exports.getCarouselIds = getCarouselIds;
exports.promoteResults = promoteResults;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _trim2 = _interopRequireDefault(require("lodash/trim"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _index = require("../constants/index.js");
function promoteResults(results, adPromotions, config) {
  var promotedResults = [].concat(results);
  var productAdPlacements = (0, _filter2["default"])(adPromotions, {
    campaignProduct: config.product
  });
  (0, _each2["default"])(productAdPlacements, function (adPlacement) {
    var id = adPlacement.id,
      position = adPlacement.position;
    var resultIndex = (0, _findIndex2["default"])(promotedResults, function (result) {
      return String(result[config.id]) === id;
    });
    if (resultIndex !== -1) {
      var _promotedResults$spli = promotedResults.splice(resultIndex, 1),
        promotedResult = _promotedResults$spli[0];
      var promotedIndex = position - 1;
      promotedResults.splice(promotedIndex, 0, (0, _extends2["default"])({}, promotedResult, {
        isPromoted: true,
        adPlacement: adPlacement
      }));
    }
  });
  return promotedResults;
}
function getAdSolutionHost(env) {
  if (env === _index.ENV.LIVE) return _index.HOSTS.AD_SOLUTION.LIVE;
  if (env === _index.ENV.STAGING) return _index.HOSTS.AD_SOLUTION.DEV;
  if (env === _index.ENV.DEV) return _index.HOSTS.AD_SOLUTION.DEV;
  return '';
}
function constructAdInteractionURL(url, baseURL) {
  return url === null || url === void 0 ? void 0 : url.replace(_index.HOSTS.AD_SOLUTION.LIVE, "" + baseURL + _index.HOSTS.AD_SOLUTION.PATHNAME);
}
function getCarouselIds(ids) {
  return (0, _map2["default"])(ids === null || ids === void 0 ? void 0 : ids.split(','), _trim2["default"]);
}